
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface InfradigitalConfig {
  bill_url: string;
  biller_code: string;
}

export function useSubscriptionConfig() {
  const [infradigitalConfig, setInfradigitalConfig] = useState<InfradigitalConfig | null>(null);

  const fetchInfradigitalConfig = async () => {
    try {
      const { data, error } = await supabase
        .from('infradigital_config')
        .select('key, value')
        .in('key', ['bill_url', 'biller_code']);

      if (error) throw error;

      if (data && data.length > 0) {
        const config: InfradigitalConfig = {
          bill_url: '',
          biller_code: ''
        };

        data.forEach(item => {
          if (item.key === 'bill_url') config.bill_url = item.value;
          if (item.key === 'biller_code') config.biller_code = item.value;
        });

        setInfradigitalConfig(config);
      }
    } catch (error) {
      console.error('Fetching Infradigital config error:', error);
    }
  };

  useEffect(() => {
    fetchInfradigitalConfig();
  }, []);

  return { infradigitalConfig };
}
